function popupSlide() {
  //   try {
  //     let popupImg = new Swiper('.popup-img', {
  //       slidesPerView: 1,
  //       spaceBetween: 10,
  //       // slidesPerColumn: 2,
  //       // slidesPerColumnFill: 'row',
  //       // // autoHeight: true,
  //       // observer: true,
  //       // observeParents: true,
  //       // simulateTouch: false,
  //       // scrollbar: {
  //       //   el: '.swiper-scrollbar',
  //       //   // hide: false,
  //       //   draggable: true,
  //       // },
  //       navigation: {
  //         nextEl: '.prev-img',
  //         prevEl: '.next-img',
  //       },
  //       // breakpoints: {
  //       //   1340: {
  //       //     slidesPerView: 4,
  //       //     spaceBetween: 10,
  //       //     slidesPerColumn: 2,
  //       //     slidesPerColumnFill: 'row',
  //       //   },
  //       //   1080: {
  //       //     slidesPerView: 3,
  //       //     spaceBetween: 0,
  //       //     slidesPerColumn: 2,
  //       //     slidesPerColumnFill: 'row',
  //       //   },
  //       //   867: {
  //       //     slidesPerView: 2,
  //       //     spaceBetween: 0,
  //       //     slidesPerColumn: 2,
  //       //     slidesPerColumnFill: 'row',
  //       //   },
  //       //   200: {
  //       //     slidesPerView: 1,
  //       //     spaceBetween: 0,
  //       //     slidesPerColumn: 2,
  //       //     slidesPerColumnFill: 'row',
  //       //     pagination: {
  //       //       el: '.swiper-pagination',
  //       //       type: 'fraction',
  //       //     },
  //       //   },
  //       // },
  //     });
  //   } catch (error) {}
  //   $('.popup-img').slick({
  //     dots: true,
  //     infinite: true,
  //     speed: 300,
  //     slidesToShow: 1,
  //     adaptiveHeight: true,
  //   });
}
